import React      from "react";
import * as utils from "../utils";

/**
 * Google's reCAPTCHA script, loaded by the first form that shows a captcha (agers-webapp-6).
 * index.html used to load it on every page, a few hundred kB of script that only the contact
 * and feedback forms use. Not in development, where index.tsx strips Google's scripts too.
 */
const RECAPTCHA_SCRIPT = `https://www.google.com/recaptcha/api.js`;
const loadRecaptchaScript = (): void => {
    if (utils.isDevelopment() || document.querySelector(`script[src="${RECAPTCHA_SCRIPT}"]`) !== null) {
        return;
    }

    const script = document.createElement(`script`);
    script.src   = RECAPTCHA_SCRIPT;
    script.async = true;
    document.head.appendChild(script);
};

interface Props {
}

interface State {
    ref: React.RefObject<HTMLDivElement>;
}

class ReCAPTCHA extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            ref : React.createRef<HTMLDivElement>(),
        };
    }

    componentDidMount() {
        loadRecaptchaScript();
        this.renderCaptcha();
    }

    renderCaptcha() {
        // @ts-ignore
        if (window.grecaptcha !== undefined) {
            // @ts-ignore
            window.grecaptcha.ready(
                // @ts-ignore
                () => window.grecaptcha.render(
                    this.state.ref.current as HTMLDivElement,
                    {
                        sitekey  : `6LetvfUiAAAAAD7wNKu88HFrWsMMYmI4VbXhALMx`,
                        callback : (token: string | null) => token !== null
                            && utils.ws.sent(
                                `verify`,
                                `recaptcha`,
                                {
                                    response : token
                                },
                            ),
                        theme    : utils.storage.features.get(`theme`) === `dark` ? `dark` : `light`
                    }
                )
            );
        } else {
            setTimeout(
                () => this.renderCaptcha(),
                1000
            );
        }
    }

    render() {
        return <div ref={this.state.ref} />;
    }
}

export default ReCAPTCHA;